import { RootState } from "../../store/store";

export const selectExtension = (state: RootState) => state.extension;
